import React, { useEffect, useRef, useState } from "react";
import { Send, MessageSquare } from "lucide-react";

export default function DuelChat({ messages, myUserId, onSend }) {
  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (open) bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, open]);

  const send = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setText("");
  };

  return (
    <div className="fixed bottom-6 right-6 z-30" data-testid="duel-chat-widget">
      {open && (
        <div className="w-72 h-80 glass-panel rounded-2xl flex flex-col mb-3 overflow-hidden" data-testid="duel-chat-panel">
          <div className="px-4 py-2.5 border-b border-white/10 flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Duel Chat</span>
            <button onClick={() => setOpen(false)} data-testid="duel-chat-close-btn" className="text-slate-400 hover:text-white text-xs">✕</button>
          </div>
          <div className="flex-1 overflow-y-auto px-3 py-2 space-y-2" data-testid="duel-chat-messages">
            {messages.length === 0 && <p className="text-[11px] text-slate-400 text-center mt-6">Say hi to your opponent!</p>}
            {messages.map((m, i) => (
              <div key={i} className={`text-xs max-w-[85%] px-3 py-1.5 rounded-lg ${m.user_id === myUserId ? "bg-indigo-500/20 text-indigo-100 ml-auto" : "bg-white/10 text-slate-200"}`} data-testid={`duel-chat-message-${i}`}>
                {m.text}
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
          <div className="p-2 border-t border-white/10 flex items-center gap-1.5">
            <input
              value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Type a message..." maxLength={280} data-testid="duel-chat-input"
              className="flex-1 bg-white/5 border border-white/10 rounded-lg px-2.5 py-1.5 text-xs text-white focus:outline-none focus:ring-1 focus:ring-indigo-400"
            />
            <button onClick={send} data-testid="duel-chat-send-btn" className="p-1.5 rounded-lg bg-indigo-500/20 text-indigo-300 hover:bg-indigo-500/30"><Send className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      )}
      <button onClick={() => setOpen((o) => !o)} data-testid="duel-chat-toggle-btn" className="w-12 h-12 rounded-full bg-primary hover:bg-primary/90 text-white flex items-center justify-center shadow-lg relative">
        <MessageSquare className="w-5 h-5" />
        {!open && messages.length > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-rose-500 text-[9px] font-bold flex items-center justify-center" data-testid="duel-chat-unread-badge">{messages.length}</span>}
      </button>
    </div>
  );
}
